import JavascriptDataType from "../stringLiterals/JavascriptDataType";


//TESTED
const formatFirstLetterAsCapital = function(input){

    let newInput = input;
    if(typeof input === JavascriptDataType.STRING){

        const originalCharAtZero = input.charAt(0);
        const charAtZeroUppercase = input.charAt(0).toUpperCase();
        const capitalFirstLetter = input.replace(originalCharAtZero, charAtZeroUppercase);

        const spacedCamelCase = capitalFirstLetter.replace(/[A-Z]/g, ' $&').trim();      

        newInput = spacedCamelCase
    }

    return newInput;
}


 const StringFormatter = Object.freeze({

    formatFirstLetterAsCapital: formatFirstLetterAsCapital
});

export default StringFormatter;